import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
}

export function formatQuantity(qty: number | null | undefined): string {
  if (qty === null || qty === undefined) return '—';
  return Number.isInteger(qty) ? String(qty) : qty.toFixed(2);
}

// Supplier dispatch channels as admins talk about them: EDI partners vs. the
// suppliers we reach by email/SMS (PDF-by-email included) or their website.
const CHANNEL_LABELS: Record<string, string> = {
  sftp_edi: 'EDI',
  email: 'Email/SMS',
  pdf_email: 'Email/SMS',
  website: 'Website',
};

export function channelLabel(channel: string | null | undefined): string {
  if (!channel) return '—';
  return CHANNEL_LABELS[channel] ?? channel;
}

// Time left until a deadline, Amazon style: "2h 48m", "1d 4h", "12m".
export function formatCountdown(ms: number): string {
  if (ms <= 0) return 'closed';
  const minutes = Math.ceil(ms / 60_000);
  const d = Math.floor(minutes / 1440);
  const h = Math.floor((minutes % 1440) / 60);
  const m = minutes % 60;
  if (d > 0) return `${d}d ${h}h`;
  if (h > 0) return `${h}h ${m.toString().padStart(2, '0')}m`;
  return `${m}m`;
}

// "Wed, Oct 30" for a delivery day.
export function formatDeliveryDay(iso: string | null | undefined): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' });
}

// "3:30 PM" today, "Thu 3:30 PM" on another day.
export function formatTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  const today = d.toDateString() === new Date().toDateString();
  return d.toLocaleString(undefined, { weekday: today ? undefined : 'short', hour: 'numeric', minute: '2-digit' });
}
